import React from 'react';
import {
  ShowController,
  ShowView,
  TabbedShowLayout,
  Tab,
  TextField,
  EmailField,
  ImageField,
  DateField,
  FunctionField,
  ReferenceField,
  ReferenceManyField,
  Datagrid,
  EditButton,
} from 'react-admin';
import UserTitle from './UserTitle';
import UserShowActions from './UserShowActions';
import BooleanIntegerField from '../../../fields/BooleanIntegerField';

const UserShow = props => {
  const renderAddressTab = controllerProps => {
    if (!controllerProps.record || controllerProps.record.role.name === 'player') {
      return null;
    }

    const fullAddress = controllerProps.record.billing_address
      ? [
          controllerProps.record.billing_address.line1,
          controllerProps.record.billing_address.line2,
          controllerProps.record.billing_address.city,
          controllerProps.record.billing_address.province,
          controllerProps.record.billing_address.zip_code,
          controllerProps.record.billing_address.country,
        ]
          .filter(Boolean)
          .join(', ')
      : '';

    return (
      <Tab label="Address" path="address">
        <TextField label="Codice Fiscale" source="id_code" />
        <FunctionField label="Address" render={() => fullAddress} />
      </Tab>
    );
  };

  const renderCoachTab = ({ record }) => {
    if (!record || !record.info || record.role.name !== 'coach') return null;

    return (
      <Tab label="Coach" path="coach">
        <TextField label="Card number" source="info.card_number" />
        {record.info.company_id && (
          <ReferenceField label="Company" source="info.company_user_id" reference="users" linkType="show">
            <TextField source="full_name" />
          </ReferenceField>
        )}
        <FunctionField label="VCorsi" render={user => (user.info && user.info.remote_user_id ? 'Yes' : 'No')} />
        <TextField label="VCorsi remote user ID" source="info.remote_user_id" />
      </Tab>
    );
  };

  const renderPlayerTab = ({ record }) => {
    if (!record || !record.info || record.role.name !== 'player') return null;

    return (
      <Tab label="Player" path="player">
        <TextField source="info.card_number" />
        <FunctionField
          label="Primary role"
          render={user => (user.info.primary_role ? user.info.primary_role.name.replace('_', ' ') : '')}
        />
        <FunctionField
          label="Secondary role"
          render={user => (user.info.secondary_role ? user.info.secondary_role.name.replace('_', ' ') : '')}
        />
        <TextField label="Primary foot" source="info.primary_foot_string" />
        <TextField label="Shirt number" source="info.shirt_number" />
        <TextField label="Facebook page" source="info.facebook_page" />
      </Tab>
    );
  };

  const renderCompanyTab = ({ record }) => {
    if (!record || !record.info || record.role.name !== 'company') return null;

    return (
      <Tab label="Company" path="company">
        <TextField label="Code" source="info.code" />
        <TextField label="President" source="info.president" />
        <TextField label="Fax number" source="info.fax_number" />
        <TextField label="Website" source="info.website" />
        <TextField label="Referent name" source="info.name_ref" />
        <TextField label="Referent phone number" source="info.phone_number_ref" />
        <EmailField label="Referent email" source="info.email_ref" />
        <TextField label="Referent skype" source="info.skype_ref" />
      </Tab>
    );
  };

  const renderSubscriptionsTab = ({ record }) => {
    if (!record) return null;

    return (
      <Tab label="Subscriptions" path="subscriptions">
        <ReferenceManyField reference="subscriptions" target="user_id" addLabel={false}>
          <Datagrid>
            <TextField source="id" label="ID" />
            <DateField label="Start at" source="start_at_europe" showTime />
            <DateField label="End at" source="end_at_europe" showTime />
            <DateField label="Payed at" source="payed_at_europe" showTime />
            <TextField source="transaction_id" />
            <TextField label="Plan" source="plan.name" />
            <FunctionField label="Price" render={subscription => (subscription ? `€${subscription.amount}` : '')} />
            <EditButton />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    );
  };

  const renderLoginsListTab = ({ record }) => {
    if (!record) return null;

    return (
      <Tab label="Login List" path="login_list">
        <ReferenceManyField reference="users/login_history" target="user_id" addLabel={false}>
          <Datagrid>
            <TextField label="ID" source="id" />
            <DateField label="Login day" source="date" showTime />
            <TextField label="Quantity" source="quantity" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    );
  };

  return (
    <ShowController {...props}>
      {controllerProps => (
        <ShowView {...props} {...controllerProps} title={<UserTitle />} actions={<UserShowActions />}>
          <TabbedShowLayout>
            <Tab label="General">
              <TextField label="ID" source="id" />
              <TextField label="Old ID" source="old_id" />
              <TextField source="full_name" />
              {controllerProps.record &&
                controllerProps.record.info.date_of_birth && (
                  <DateField label="Date of birth" source="info.date_of_birth" />
                )}
              <TextField label="Role" source="role.name" />
              <ImageField addLabel label="Avatar" source="avatar_urls.original" />
              <EmailField source="email" />
              <TextField source="phone_number" />
              <BooleanIntegerField label="Is active" source="is_active" />
              <DateField source="created_at" showTime />
              <DateField source="updated_at" showTime />
              <DateField source="confirmed_at" showTime />
              <DateField source="last_login_at" showTime />
            </Tab>
            {renderAddressTab(controllerProps)}
            {renderCoachTab(controllerProps)}
            {renderPlayerTab(controllerProps)}
            {renderCompanyTab(controllerProps)}
            {renderSubscriptionsTab(controllerProps)}
            {renderLoginsListTab(controllerProps)}
          </TabbedShowLayout>
        </ShowView>
      )}
    </ShowController>
  );
};

export default UserShow;



// WEBPACK FOOTER //
// ./src/resources/users/show/UserShow.jsx